<template>
    <q-card flat bordered>
        <q-card-section class="Activities flex row-left-center">
            <q-btn
                v-for="({ label, id, readOnly }) in options"
                :key="id"
                :disable="readOnly"
                class="q-pa-md"
                noCaps
                dense
                flat
                @click="handleClickFilter({ label, id, readOnly })"
            >
                <div class="Item flex row-left-center flex-nowrap">
                    <FilterIcon :id="id" height="32px" width="32px" />
                    <WText
                        class="pl-1"
                        tag="p"
                        weight="medium"
                    >
                        {{ label }}
                    </WText>
                </div>
            </q-btn>
        </q-card-section>
    </q-card>
</template>

<script>
import VueTypes from 'vue-types'
import FilterIcon from './FilterIcon.vue'

export default {
    name: 'FilterModalSection',
    components: { FilterIcon },
    props: {
        options: VueTypes.array,
        title: VueTypes.string,
    },
    emits: ['onClickFilter'],
    methods: {
        handleClickFilter({ label, id, readOnly }) {
            if (!readOnly) this.$emit('onClickFilter', { label, id })
        },
    },
}
</script>
<style lang="scss" scoped>

    .Activities  {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 10px;
        .q-btn {
            height: 100%;
            display: flex;
            width: 100%;
            align-items: baseline !important;
            &:deep(.Body) {
                width: 100%;
                padding: 0;
                .Item {
                    padding: 20px;
                }
            }
        }
        .q-card:hover{
            box-shadow: 0px 0px 5px 5px $alpha-primary;
            border: solid 1px rgba(68, 68, 68, 0.2);
        }
        @media screen and (min-width: $md) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media screen and (min-width: $lg) {
            grid-template-columns: repeat(3, minmax(10px, 280px));
        }
        @media screen and (min-width: $xl) {
            grid-template-columns: repeat(4, minmax(10px, 280px));
        }
    }
</style>
